import { render, staticRenderFns } from "./company-news.vue?vue&type=template&id=fc9cd280&scoped=true&"
import script from "./company-news.vue?vue&type=script&lang=js&"
export * from "./company-news.vue?vue&type=script&lang=js&"
import style0 from "./company-news.vue?vue&type=style&index=0&id=fc9cd280&scoped=true&lang=scss&"
import style1 from "./company-news.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9cd280",
  null
  
)

export default component.exports